module.exports = __webpack_public_path__ + "static/media/email-marketing.d9741934.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/email-marketing.svg
// module id = 319
// module chunks = 0